import { IReduxStore } from "Redux/Store/IReduxStore";

export const getTotalPrice = (state: IReduxStore) => {
    let total = 0;
    Object.keys(state.basket.basketEntries).forEach(id => {
        total += state.basket.basketEntries[id].totalPrice * state.basket.basketEntries[id].amount;
    });

    return total;
}